import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  flex: 1;
  margin: 20px;
  position: relative;
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
`

export const Message = styled.p`
  font-size: 0.8rem;
  color: #545e6c;
  text-align: center;
  padding-top: 50%;
`

export const ReturnArrowButton = styled.button`
  position: absolute;
  top: 0;
  left: 0px;
  border: none;
  background: none;
  transform: translateY(-49px);
  font-size: 0;

  cursor: pointer;

  svg {
    color: #9ba8ba;
  }
  &:hover svg {
    color: #6a7380;
  }
`

export const BreadCrumbsContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
`

export const BackButtonContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`

export const RelatedContentContainer = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  overflow: auto;
`

export const RelatedProcedureSkeleton = styled(Skeleton).attrs({
  baseColor: '#f2f7ff',
  'data-testid': 'related-procedure-skeleton'
})`
  margin-top: 7px;
  height: 40px;
  border-radius: 4px;
`
